module.exports = __webpack_public_path__ + "static/default-image.b10b8496.svg";